import { z } from "@/zod";
import { ulid, dateTime } from "@/schemas/commonFields";

export enum ASSIGNMENT_TYPES {
  RR_2_RD = "rr_2_rd",
  RR_2_FAM = "rr_2_fam",
  KAM_2_CSD = "kam_2_csd",
}

export const supervisor = z.object({
  supervisor_id: ulid,
  supervisor_name: z.string(),
  supervisor_role_id: ulid,
  supervisor_role_code: z.string(),
  supervisor_role_name: z.string(),
});

export const subordinate = z.object({
  subordinate_id: ulid,
  subordinate_name: z.string(),
  subordinate_role_id: ulid,
  subordinate_role_code: z.string(),
  subordinate_role_name: z.string(),
});

export const structureAssignment = z.object({
  id: ulid,
  ...supervisor.shape,
  ...subordinate.shape,
  assignment_type: z.nativeEnum(ASSIGNMENT_TYPES),
  is_primary: z.boolean(),
  comment: z.string().nullable(),
  updated_at: dateTime,
});

export const readStructureAssignment = structureAssignment.readonly();

export const writeSubordinate = z.object({
  subordinate_id: ulid,
  is_primary: z.boolean(),
  comment: z.string(),
});

export const writeStructureAssignment = z.object({
  supervisor_id: ulid,
  assignment_type: z.nativeEnum(ASSIGNMENT_TYPES),
  subordinates: z.array(writeSubordinate),
});
